<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md5 offset-md7>
        <v-text-field
          class="border-container"
          prepend-inner-icon="search"
          v-model="filters.search"
          label="Nombre del horario"
          solo
          flat
          hide-details
        />
      </v-flex>
      <v-flex xs12 md4>
        <v-card flat class="border-container">
          <v-card-text class="py-4">
            <strong>Tipo de horario</strong>
            <v-radio-group v-model="filters.type" hide-details>
              <v-radio
                color="red"
                value="FULL_TIME"
                :class="[
                  filters.type == 'FULL_TIME' ? 'radio-selected' : '',
                  'radio-border',
                  'radio-up',
                ]"
              >
                <template v-slot:label>
                  <div>
                    <strong
                      :class="[filters.type == 'FULL_TIME' ? 'red--text' : '']"
                    >
                      Tiempo completo
                    </strong>
                    <div>
                      Permite crear un horario donde la hora de ingreso y salida
                      es la misma para cada día hábil del colegio.
                    </div>
                  </div>
                </template>
              </v-radio>
              <v-radio
                color="red"
                value="HOURS_BY_DAY"
                :class="[
                  filters.type == 'HOURS_BY_DAY' ? 'radio-selected' : '',
                  'radio-border',
                  'radio-down',
                ]"
              >
                <template v-slot:label>
                  <div>
                    <strong
                      :class="[
                        filters.type == 'HOURS_BY_DAY' ? 'red--text' : '',
                      ]"
                    >
                      Por horas
                    </strong>
                    <div>
                      Permite crear un horario donde la hora de ingreso y salida
                      puede ser distinta por cada día hábil del colegio.
                    </div>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md8>
        <v-card flat class="border-container">
          <v-card-text class="px-0 py-0">
            <v-data-table
              :headers="getHeaders"
              :items="schedules"
              :loading="tableLoading"
              :pagination.sync="pagination"
              :rows-per-page-items="[25, 50, 100]"
              rows-per-page-text="Registros por página"
              no-results-text="No hay horarios creados"
              no-data-text="No hay horarios creados"
              :total-items="totalSchedules"
            >
              <template v-slot:headers="props">
                <tr style="background-color: #dddddd">
                  <th
                    v-for="(header, index) in props.headers"
                    :key="header.text"
                    :style="index==0 ? 'width:70%;text-align: left !important': 'width:30%;text-align: center !important'"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>

              <template v-slot:items="props">
                <tr>
                  <td
                    style="width:70%; text-align:left !important"
                  >
                    {{ props.item.name }}
                  </td>
                  <td class="px-0" style="width:30%; text-align:center !important;">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <button v-on="on" class="v-pagination__item" @click="detailSchedule(props.item.id)">
                          <v-icon small> visibility </v-icon>
                        </button>
                      </template>
                      <span>Ver detalle</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <button v-on="on" v-if="permits['UPDATE_SCHEDULE_COLLABORATOR']" class="v-pagination__item"
                          @click="editSchedule(props.item.id)">
                          <v-icon small> edit </v-icon>
                        </button>
                      </template>
                      <span>Editar horario</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <button v-on="on" v-if="permits['DELETE_SCHEDULE_COLLABORATOR']" class="v-pagination__item"
                          @click="
                            () => {
                              confirmDelete.modal = true;
                              confirmDelete.deleteId = props.item.id;
                            }
                          ">
                          <v-icon small> delete </v-icon>
                        </button>
                      </template>
                      <span>Eliminar horario</span>
                    </v-tooltip>

                  </td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }} resultados
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <Confirm
      :value="confirmDelete.modal"
      title="Eliminar"
      description="¿Estas seguro que deseas eliminar el horario? Esta acción eliminará definitivamente el horario."
      v-on:desition="deleteSchedule"
    />
		<error v-model="toast.failed" text="Ups ocurrió un error"></error>
		<loading v-model="toast.working" text="Trabajando..."></loading>
    <alert v-model="toast.unauthorized" title="Aviso" description="No cuentas con los permisos para realizar esta acción"></alert>
  </v-container>
</template>

<script>
import Confirm from "../../Dialogs/Confirm.vue";
import error from "../../Dialogs/Error.vue";
import loading from "../../Dialogs/Loading.vue";
import alert from "../../Dialogs/Alert.vue";
export default {
  components: {
    Confirm,
    error,
    loading,
    alert,
  },
  props: ["permits"],
  data() {
    return {
      confirmDelete: {
        modal: false,
        deleteId: null,
      },
      initialValues: null,
      tableLoading: false,
      pagination: {},
      filters: { type: "FULL_TIME", search: "" },
      schedules: [],
      totalSchedules: 0,
      headers: [
        {
          text: "HORARIOS DE TIEMPO COMPLETO",
          value: "name",
          sortable: false,
          width: "70%",
          align: "left",
        },
        {
          text: "ACCIONES",
          sortable: false,
          width: "30%",
          align: "left",
        },
      ],
      toast: {
        failed: false,
        working: false,
        unauthorized: false,
      }
    };
  },
  methods: {
    detailSchedule(scheduleId) {
      this.$router.push({
        name: "scheduleDetail",
        params: { id: scheduleId },
      });
    },
    editSchedule(scheduleId) {
      this.$router.push({
        name: "scheduleUpdate",
        params: { id: scheduleId },
      });
    },
    listSchedules(filters, pagination) {
      this.tableLoading = true;
      const query = {
        ...filters,
        size: pagination.rowsPerPage,
        offset: (pagination.page - 1) * pagination.rowsPerPage,
      };
      this.$store
        .dispatch("checker/listSchedule", query)
        .then((res) => {
          this.schedules = res.data.list.reverse();
          this.totalSchedules = res.data.total;
        })
        .catch((e) => {
          console.log(e)
          this.toast.failed= true;
        })
        .finally(() =>this.tableLoading = false);
    },
    deleteSchedule(confirm) {
      if (confirm) {
        this.toast.working= true;
        const { deleteId } = this.confirmDelete;
        this.$store
          .dispatch("checker/deleteSchedule", deleteId)
          .then(response => {
            if(response.data && response.data.code === 1017) {
              this.toast.unauthorized = true;
              return;
            }

            this.schedules = this.schedules.filter((i) => i.id !== deleteId);
          })
          .catch( e => {
            console.log(e)
            this.toast.failed= true;
          })
          .finally(() => this.toast.working = false);
      }
      this.confirmDelete = {
        modal: false,
        deleteId: null,
      };
    },
  },
  mounted() {
    this.listSchedules(this.filters, this.pagination);
  },
  watch: {
    pagination: {
      handler() {
        this.listSchedules(this.filters, this.pagination);
      },
      deep: true,
    },
    filters: {
      handler() {
        this.listSchedules(this.filters, this.pagination);
      },
      deep: true,
    },
  },
	computed: {
    getHeaders() {
      let headerText = this.filters.type=="FULL_TIME"?
                  "HORARIOS DE TIEMPO COMPLETO": "HORARIOS POR HORAS";
      this.headers[0].text = headerText;
      return this.headers;
    },
  }
};
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}

/deep/ .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

/deep/ .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
</style>